import { jsx as c } from "react/jsx-runtime";
import m from "@mui/material/SvgIcon";
import * as o from "react";
import { forwardRef as l } from "react";
const f = (t) => /* @__PURE__ */ o.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "6 6 20 20", ...t }, /* @__PURE__ */ o.createElement("path", { fill: "currentColor", d: "M26 6.712v-.284c0-.072-.074-.143-.148-.143v-.071c-.074-.072-.148-.072-.222-.143h-.074c-.075 0-.149 0-.223-.071h-.37L6.444 14.54c-.222.286-.444.5-.444.713s.074.498.296.64l3.852 2.776 5.037-3.915c.297-.213.815-.213 1.037.143.222.284.222.783-.148.996l-4.889 3.773v5.622c0 .285.222.57.519.64.074.072.148.072.222.072.222 0 .444-.071.592-.285L15.26 22.3l2.89 2.064c.147.071.295.142.444.142h.222c.222-.07.37-.213.518-.427L26 6.996zq0 .105 0 0" })), s = /* @__PURE__ */ l(({ size: t = "inherit", sx: e, ...n }, r) => {
  const i = typeof e == "function" ? e : {
    fontSize: t,
    ...e
  };
  return /* @__PURE__ */ c(m, {
    ...n,
    ref: r,
    component: f,
    inheritViewBox: !0,
    sx: i
  });
});
s.displayName = "svg_invite";
export {
  s as default
};
